import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Check, X } from "lucide-react";
import { ProductPrice } from "@/components/ProductPrice";

export const ProductDialog = ({ product, onClose, phone, phoneTel, whatsappLink }) => (
  <Dialog open={!!product} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="w-[calc(100vw-1.5rem)] sm:w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl p-0 bg-slate-950 border-slate-800 text-slate-200 [&>button]:w-9 [&>button]:h-9 [&>button]:rounded-full [&>button]:bg-slate-900 [&>button]:border [&>button]:border-slate-700 [&>button]:flex [&>button]:items-center [&>button]:justify-center [&>button]:opacity-100 [&>button]:text-slate-200 [&>button]:hover:bg-rose-600 [&>button_svg]:w-5 [&>button_svg]:h-5" data-testid="product-dialog">
      {product && (
        <div className="grid grid-cols-1 sm:grid-cols-2">
          <div className="h-48 sm:h-auto bg-slate-900 border-b sm:border-b-0 sm:border-r border-slate-800">
            <img src={product.img} alt={product.name} className={`w-full h-full ${product.contain ? "object-contain p-3" : "object-cover"}`} data-testid="product-dialog-image" />
          </div>
          <div className="p-6 sm:p-7 flex flex-col">
            <DialogHeader className="text-left space-y-1">
              <span className="text-[11px] font-semibold uppercase tracking-widest text-rose-400">Fancy Saloon Formulation</span>
              <DialogTitle className="text-2xl font-bold text-white" data-testid="product-dialog-title">{product.name}</DialogTitle>
              {product.brand && <div className="text-xs font-semibold text-emerald-300" data-testid="product-dialog-brand">{product.brand}</div>}
              <DialogDescription className="text-sm text-slate-400">{product.desc}</DialogDescription>
            </DialogHeader>

            <div className="mt-5 space-y-4 text-sm">
              <div>
                <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Best for</div>
                <p className="text-slate-300" data-testid="product-dialog-bestfor">{product.bestFor}</p>
              </div>
              {product.ingredients && (
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Ingredients</div>
                  <div className="flex flex-wrap gap-1.5" data-testid="product-dialog-ingredients">
                    {product.ingredients.map((ing) => (
                      <span key={ing} className="text-[11px] px-2 py-0.5 rounded-md bg-emerald-500/10 border border-emerald-500/30 text-emerald-200">{ing}</span>
                    ))}
                  </div>
                </div>
              )}
              <div>
                <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Benefits</div>
                <ul className="space-y-1.5">
                  {product.benefits.map((b) => (
                    <li key={b} className="flex items-start gap-2 text-slate-300">
                      <Check className="w-4 h-4 mt-0.5 text-rose-400 shrink-0" /> {b}
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1.5">How to use</div>
                <p className="text-slate-300">{product.usage}</p>
                {product.guideImg && (
                  <a href={product.guideImg} target="_blank" rel="noreferrer" data-testid="product-dialog-guide-link" className="mt-3 block rounded-xl overflow-hidden border border-slate-800 hover:border-rose-500/60 transition-colors">
                    <img src={product.guideImg} alt={`${product.name} step-by-step usage instructions`} className="w-full h-auto" data-testid="product-dialog-guide-image" />
                    <span className="block text-center py-2 text-[11px] uppercase font-bold tracking-wider text-rose-300 bg-slate-900">Tap to view full instruction card</span>
                  </a>
                )}
              </div>
              <div className="flex items-center justify-between rounded-xl bg-slate-900 border border-slate-800 px-4 py-3">
                <span className="text-xs text-slate-400">Size</span>
                <span className="text-xs font-semibold text-slate-200">{product.size}</span>
              </div>
              <div className="flex items-center justify-between rounded-xl bg-rose-500/10 border border-rose-500/30 px-4 py-3">
                <span className="text-xs text-rose-200">Price</span>
                <ProductPrice product={product} testId="product-dialog-price" />
              </div>
            </div>

            <div className="mt-6 grid grid-cols-2 gap-3">
              <a href={phoneTel} data-testid="product-dialog-call-btn" className="inline-flex items-center justify-center py-3 rounded-xl bg-rose-600 hover:bg-rose-500 text-white text-xs font-bold uppercase tracking-wider transition-colors">
                Call {phone}
              </a>
              <a href={`${whatsappLink}${encodeURIComponent(` I am interested in ${product.name}.`)}`} target="_blank" rel="noreferrer" data-testid="product-dialog-whatsapp-btn" className="inline-flex items-center justify-center py-3 rounded-xl bg-[#25D366] hover:bg-[#1ebe5b] text-slate-950 text-xs font-bold uppercase tracking-wider transition-colors">
                WhatsApp
              </a>
            </div>
            <button
              type="button"
              onClick={onClose}
              data-testid="product-dialog-close-btn"
              className="mt-3 inline-flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-slate-900 hover:bg-slate-800 border border-slate-700 text-slate-200 text-xs font-bold uppercase tracking-wider transition-colors"
            >
              <X className="w-4 h-4" /> Close
            </button>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
